import React, { useEffect, useState } from 'react'
import { ExplanationOfBenefitBundle } from '../../../../../types/FHIRTypes/Bundle'
import { useHistory } from 'react-router-dom'
import { ExplanationOfBenefit as FHIRExplanationOfBenefit } from '@teschglobal/tg-fhir-react-components/dist/types'
import { ExplanationOfBenefit } from '@teschglobal/tg-fhir-react-components'
import FhirLoader from '../../../../FhirLoader'
import useFhirConfig from '../../../../../hooks/admin/useFhirConfig'
import { appConfig } from '../../../../../assets/customizations/config'
import useFhirResourceById from '../../../../../hooks/admin/useFhirResourceById'
import { UseQueryResult } from 'react-query'

type EobDetailProps = {
  eobDetailId: string;
}

const EobDetail: React.FC<EobDetailProps> = ({ eobDetailId }) => {
  const { patientAccessFhirConfig, handleSelectOrganization, handleSelectPractitioner } = useFhirConfig()

  const {
    data: eobs,
    isFetching,
    isLoading,
    isError
  }: UseQueryResult<FHIRExplanationOfBenefit, Error> =
    useFhirResourceById('Patient Access', eobDetailId || '', 'ExplanationOfBenefit')

  if (isFetching || isLoading) {
    return <FhirLoader />
  }

  if (!eobs || isError) {
    return <div className='text-center' role='status' aria-live='polite' aria-atomic='true'>Not Found</div>
  }


  return (
    <div>
      <section>
        <ExplanationOfBenefit
          data={eobs}
          fhirApiConfig={patientAccessFhirConfig}
          onSelectOrganization={handleSelectOrganization}
          onSelectPractitioner={handleSelectPractitioner}
          showMemberResponsibility={appConfig.use_eob_member_responsibility}
        />
      </section>
    </div>
  )
}
export default EobDetail